module.exports = __webpack_public_path__ + "img/creator-banner.fb73ef1a.jpg";